/**
 * Keys that are not stored per environment type in session storage
 */
export enum RawSessionStorageKeys {
    NavigatorPushIndex = 'navigator.pushIndex',
    FlightSearchScheduleCache = 'flightSearch.scheduleCache',
    FlightSearchLowFaresCache = 'flightSearch.lowFaresCache',
}

